import React, { useState, useEffect } from 'react';
import API from '../api';
import { useNavigate } from 'react-router-dom';
import './login.css';
import logo from '../assets/merchant-marvels.jpg';
import { jwtDecode } from 'jwt-decode';

function EmployeeLogin() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Google Sign-In for employees
  useEffect(() => {
    const initializeGoogle = () => {
      if (window.google && window.google.accounts) {
        window.google.accounts.id.initialize({
          client_id:
            '970749154398-4dcmlam48s2lqe5gqer3esm85dkchogs.apps.googleusercontent.com',
          callback: handleGoogleCallback,
        });

        window.google.accounts.id.renderButton(
          document.getElementById('googleSignInDivEmployee'),
          { theme: 'outline', size: 'large', width: '100%' }
        );
      } else {
        setTimeout(initializeGoogle, 500);
      }
    };

    initializeGoogle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGoogleCallback = async (response) => {
    try {
      const decoded = jwtDecode(response.credential);
      const { email } = decoded;

      // employee specific Google login
      const empRes = await API.post('/auth/employee-login', {
        email,
        password: '',
        isGoogle: true,
      });

      const { token, employee } = empRes.data;

      localStorage.setItem('token', token);
      localStorage.setItem(
        'user',
        JSON.stringify({
          id: employee.id,
          name: employee.name,
          email: employee.email,
          role: 'employee',
          business_id: employee.business_id,
        })
      );

      navigate('/');
    } catch (err) {
      console.error('Google employee login failed:', err);
      setError(
        'Google login failed. Please contact your admin or use email/password.'
      );
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const email = form.email?.trim();
    const password = form.password?.trim();

    if (!email || !password) {
      setError('Email and password are required.');
      return;
    }

    try {
      const res = await API.post('/auth/employee-login', { email, password });
      const { token, employee } = res.data;

      localStorage.setItem('token', token);
      localStorage.setItem(
        'user',
        JSON.stringify({
          id: employee.id,
          name: employee.name,
          email: employee.email,
          business_id: employee.business_id,
          role: 'employee',
        })
      );

      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <div className="mm-login-container">
      {/* Left side hero (same layout, employee text) */}
      <div className="mm-login-left">
        <div className="mm-welcome-message">
          <h1>Welcome Employee</h1>
          <p>
            Login to access your workspace and manage your business tasks
            efficiently.
          </p>
        </div>
      </div>

      {/* Right side form (same structure as main Login.jsx) */}
      <div className="mm-login-right">
        <div className="mm-login-logo-wrapper">
          <img
            src={logo}
            alt="Merchant Marvels"
            className="mm-login-logo"
          />
        </div>

        <div className="mm-login-form-wrapper">
          <form onSubmit={handleSubmit} className="mm-login-form">
            <h2 className="mm-login-title">Employee Login</h2>
            <p className="mm-login-subtitle">
              Use your email and password or Google account
            </p>

            {error && <div className="mm-error-message">{error}</div>}

            <div className="mm-input-wrapper">
              <div className="mm-label">Email</div>
              <input
                className="mm-login-input"
                name="email"
                type="email"
                placeholder="Enter your email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mm-input-wrapper">
              <div className="mm-label">Password</div>
              <input
                className="mm-login-input"
                name="password"
                type="password"
                placeholder="Enter password"
                value={form.password}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mm-login-options">
              <label className="mm-remember-me">
                <input type="checkbox" />
                <span>Remember Me</span>
              </label>
              <a href="/forgot-password" className="mm-link">
                Forgot Password ?
              </a>
            </div>

            <button className="mm-login-button" type="submit">
              Login
            </button>

            <p className="mm-login-footer">
            <div className="">

              Not an employee?{' '}
              <a href="/login" className="mm-link">
                Admin Login
              </a>
              </div>
            </p>

            <div className="mm-divider">
              <div className="mm-divider-line" />
              <span className="mm-divider-text">Or Sign in with</span>
              <div className="mm-divider-line" />
            </div>

            <div className="mm-google-wrapper">
              <div
                id="googleSignInDivEmployee"
                style={{ width: '100%' }}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EmployeeLogin;
